const ACCESS_DINIED_PAGE_CONTENT_KEY = 'waf-access-denied-content';

export const setAccessDeniedPageContent = (content) => sessionStorage.setItem(ACCESS_DINIED_PAGE_CONTENT_KEY, content);

export const getAccessDeniedPageContent = () => sessionStorage.getItem(ACCESS_DINIED_PAGE_CONTENT_KEY);

export const removeAccessDeniedPageContent = () => sessionStorage.removeItem(ACCESS_DINIED_PAGE_CONTENT_KEY);
